import { createFileRoute } from '@tanstack/react-router';
import { PublicCompanyPage } from '../../features/directory';

export const Route = createFileRoute('/_public/c/$slug')({
  component: function PublicCompanyRoute() {
    const { slug } = Route.useParams();
    return <PublicCompanyPage slug={slug} />;
  },
});
